module.exports = __webpack_public_path__ + "static/IBMPlexSans-Light-fe6a0ca5d5fcdf1277424ea08a746f35.woff2";